import { Site, SLD } from '@patsnap-utils/biz';
import { stringify } from 'qs';

/**
 *
 * @param id
 * @returns view link
 */
export function generatePatentViewHref(data: {
    patentId: string,
    params?: Record<string, string>,
}) {
    if (!data.patentId) return ''
    const pathname = [
        `view/#/?patentId=${data.patentId}`,
        stringify(data?.params || {})
    ].join('&')
    return new Site({ sld: SLD.EUREKA, pathname }).href
}

export function generatePaperViewHref(data: {
    solutionId: string,
    params?: Record<string, string>,
}) {
    if (!data.solutionId) return ''
    const pathname = [
        `literature/#/?paperId=${data.solutionId}`,
        stringify(data?.params || {})
    ].join('&')
    return new Site({ sld: SLD.EUREKA, pathname }).href
}

export function generateReportViewHref(data: {
    reportId: string
}) {
    if (!data.reportId) return ''
    return new Site({ sld: SLD.EUREKA, pathname: `discovery/#/market-detail/${data.reportId}` }).href
}

export enum EProjectSubType {
    PROJECT_SEEK = 'PROJECT_SEEK',
    PROJECT_MIND = 'PROJECT_MIND',
    PROJECT_FMEA = 'PROJECT_FMEA',
    PROJECT_PDF = 'PROJECT_PDF',
    PROJECT_WORD = 'PROJECT_WORD'
}

export function generateProjectViewHref(data: {
    solution: any
}) {
    if (!data.solution.SOLUTION_ID) return ''
    switch (data.solution.SOLUTION_SUB_TYPE) {
    case EProjectSubType.PROJECT_SEEK:
        return new Site({ sld: SLD.EUREKA, pathname: `page/${data.solution.SOLUTION_ID}` }).href
    case EProjectSubType.PROJECT_MIND:
        return new Site({ sld: SLD.EUREKA, pathname: `whiteboard/#/board/${data.solution.SOLUTION_ID}` }).href
    case EProjectSubType.PROJECT_PDF:
    case EProjectSubType.PROJECT_WORD:
        return new Site({ sld: SLD.EUREKA, pathname: `rd/#/graph/${data.solution.PROJECT_ID}/pdf/${data.solution.SOLUTION_ID}` }).href
    default:
        return new Site({ sld: SLD.EUREKA, pathname: `rd/#/graph/${data.solution.PROJECT_ID}` }).href
    }
}

/**
 * Generate Paper/Literature PUM (Properties, Units, Measurements) view link
 * @param data - Contains paperId and optional params
 * @returns Full URL to literature PUM view
 */
export function generatePaperPumViewHref(data: {
    paperId: string,
    params?: Record<string, string>,
}) {
    if (!data.paperId) return ''
    const pathname = [
        `literature/#/pum?paperId=${data.paperId}`,
        stringify(data?.params || {})
    ].join('&')
    return new Site({ sld: SLD.EUREKA, pathname }).href
}

/**
 * Generate Patent PUM (Properties, Units, Measurements) view link
 * @param data - Contains patentId and optional params
 * @returns Full URL to fullText PUM view
 */
export function generatePatentPumViewHref(data: {
    patentId: string,
    params?: Record<string, string>,
}) {
    if (!data.patentId) return ''
    const pathname = [
        `view/#/fullText'PUM?patentId=${data.patentId}`,
        stringify(data?.params || {})
    ].join('&')
    return new Site({ sld: SLD.EUREKA, pathname }).href
}

export const generateViewHref = generatePatentViewHref;
